const initialState = {
  loading: false,
  data: [] as any,
  error: null as any,
  testTypes: [] as string[],
  businessUnits: [] as string[],
  compositeProfile: null as any,
};

export default function applicationProfile(state = initialState, action: any) {
  switch (action.type) {
    case 'GET_APPLICATION_PROFILES_LOADING':
      return { ...state, loading: true, error: null };
    case 'GET_APPLICATION_PROFILES_SUCCESS':
      return { ...state, loading: false, data: action.payload || [] };
    case 'GET_APPLICATION_PROFILES_ERROR':
      return { ...state, loading: false, error: true };
    case 'CREATE_APPLICATION_PROFILE_LOADING':
      return { ...state, loading: true, error: null };
    case 'CREATE_APPLICATION_PROFILE_SUCCESS':
      return { ...state, loading: false };
    case 'CREATE_APPLICATION_PROFILE_ERROR':
      return { ...state, loading: false, error: true };
    case 'UPDATE_APPLICATION_PROFILE_LOADING':
      return { ...state, loading: true, error: null };
    case 'UPDATE_APPLICATION_PROFILE_SUCCESS':
      return { ...state, loading: false };
    case 'UPDATE_APPLICATION_PROFILE_ERROR':
      return { ...state, loading: false, error: true };
    case 'DELETE_APPLICATION_PROFILES_LOADING':
      return { ...state, loading: true, error: null };
    case 'DELETE_APPLICATION_PROFILES_SUCCESS':
      console.log('Deleting application profile with ID:', state?.data?.data, action.payload);
            const filteredItems = [...state?.data?.data]
                .filter((item: any) => item.ApplicationId !== action.payload);
            return { ...state, data: { data: filteredItems}, loading: false, error: false };
    case 'DELETE_APPLICATION_PROFILES_ERROR':
      return { ...state, loading: false, error: true };
    case 'GET_TEST_TYPES_LOADING':
      return { ...state, loading: true };
    case 'GET_TEST_TYPES_SUCCESS':
      return { ...state, loading: false, testTypes: action.payload || [] };
    case 'GET_TEST_TYPES_ERROR':
      return { ...state, loading: false };
    case 'GET_BUSINESS_UNITS_LOADING':
      return { ...state, loading: true };
    case 'GET_BUSINESS_UNITS_SUCCESS':
      return { ...state, loading: false, businessUnits: action.payload || [] };
    case 'GET_BUSINESS_UNITS_ERROR':
      return { ...state, loading: false };
    case 'GET_COMPOSITE_APPLICATION_PROFILE_LOADING':
      return { ...state, loading: true, error: null, compositeProfile: null };
    case 'GET_COMPOSITE_APPLICATION_PROFILE_SUCCESS':
      return { ...state, loading: false, compositeProfile: action.payload };
    case 'GET_COMPOSITE_APPLICATION_PROFILE_ERROR':
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
}
